import { Avatar, Popover } from 'antd';
import DefaultModal from 'components/common/DefaultModal';
import useUserMenu from 'hooks/useUserMenu';
import React from 'react';

import ChangePasswordModal from './ChangePasswordModal';

const UserInfo: React.FC = () => {
  const {
    onChangePasswordCancel,
    resetPasswordModalVisible,
    userMenuOptions,
    onVisibleChange,
    popoverVisibility,
    avatarURL,
    LocationSelectComponent,
    locationModalVisibility,
    onLocationModalCancel,
  } = useUserMenu(true);

  return (
    <>
      <DefaultModal
        props={{
          visible: locationModalVisibility,
          onCancel: onLocationModalCancel,
          title: 'Set Current Office Location',
        }}>
        <LocationSelectComponent />
      </DefaultModal>
      <ChangePasswordModal onCancel={onChangePasswordCancel} visible={resetPasswordModalVisible} />
      <Popover
        overlayClassName='gx-popover-horizantal'
        placement='bottomRight'
        content={userMenuOptions}
        trigger='click'
        onVisibleChange={onVisibleChange}
        visible={popoverVisibility}>
        <Avatar src={avatarURL} className='gx-avatar gx-pointer' alt='avatar' />
      </Popover>
    </>
  );
};

export default UserInfo;
